import { PaperDimension, PaperSize } from "./types";

export const paperPrintDimensions: Record<PaperSize, PaperDimension> = {
  a3: {
    width: 420,
    height: 297,
    margin: 12.7,
  },
};
